import { useEffect, useState } from 'react';
import { ActionButton, ActionLink } from '../parts/ActionButton.js';
import { CardFrame } from '../parts/primitives.js';
import { useViewing } from '../view-as.js';
import { onboarding, type TeamsConsentStatus } from './api.js';

/** U440/U441: the same permission offer in onboarding and after a refused reply. */
export function TeamsReplyPanel({ next, hadConsent = false, busy = false, onNotNow }: {
  next: string; hadConsent?: boolean; busy?: boolean; onNotNow: () => void;
}) {
  const viewing = useViewing();
  if (viewing) return null;
  return <CardFrame variant="panel">
    {hadConsent ? <p>Your permission for Cobrain to post to Teams as you has expired or been removed. Give it again to reply from here.</p> : <>
      <h2>Reply in Teams as you</h2>
      <p>One more Microsoft sign-in lets you reply and start chats in Teams from Cobrain, as you. Microsoft lists what it allows: sending, making group chats, adding people, and reading and editing your chats. Cobrain sends only what you press Send on.</p>
    </>}
    <div className="opts">
      <ActionLink className="opt lead" href={`/api/teams-consent/start?next=${encodeURIComponent(next)}`}>Allow Cobrain to reply as me</ActionLink>
      {!hadConsent && <ActionButton type="button" className="opt" disabled={busy} onClick={onNotNow}>Not now</ActionButton>}
    </div>
  </CardFrame>;
}

export function TeamsReplyOffer({ aboveApp = false }: { aboveApp?: boolean }) {
  const viewing = useViewing();
  const [consent, setConsent] = useState<TeamsConsentStatus | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let live = true;
    setConsent(null);
    if (!viewing) void (async () => {
      try { const status = await onboarding.teamsConsent(); if (live) setConsent(status); }
      catch { /* An unknown permission is never presented as a missing grant. */ }
    })();
    return () => { live = false; };
  }, [viewing]);
  const notNow = async () => {
    setBusy(true); setError(null);
    try {
      await onboarding.teamsConsentOffered();
      setConsent(status => status ? { ...status, offered: true } : status);
    } catch (e) { setError(e instanceof Error ? e.message : String(e)); }
    finally { setBusy(false); }
  };
  if (viewing || !consent?.enabled || !consent.storable || consent.granted || consent.offered) return null;
  const panel = <><TeamsReplyPanel next={`${window.location.pathname}${window.location.search}`} busy={busy} onNotNow={() => void notNow()} />{error && <p role="alert">{error}</p>}</>;
  return aboveApp ? <div className="mc onb granola-later">{panel}</div> : panel;
}
